import {
	Tenant,
	TenantStatusEnum
}                              from '@app/modules/admin-tenant/models/tenant.model';
import { AdminTenantState }    from '@app/modules/admin-tenant/store/admin-tenant.state';
import { ActionTypeWithProps } from '@core/interfaces/store.interface';
import {
	adapterActions,
	IAdapterActions,
	IBaseProps
}                              from '@core/store/adapter/adapter.actions';
import {
	createAction,
	props
}                              from '@ngrx/store';
import {
	IChangeStatusCallback,
	IChangeStatusTenantCallbackOptions,
	IStatusFlowChangeEvent
}                              from '@shared/components/status-flow/status-flow.model';


export interface IAdminTenantActions extends IAdapterActions<Tenant> {
	changeStatus: ActionTypeWithProps<IPropsChangeStatusTenantEntity>;
	updateAdminState: ActionTypeWithProps<IPropsUpdateAdminState>;
	showAccountConfiguration: ActionTypeWithProps<IPropsTenantEntity>;
	updateTenantContractLogs: ActionTypeWithProps<IPropsTenantEntity>;
}

export interface IPropsUpdateAdminState extends IBaseProps {
	stateUpdateData?: AdminTenantState;
}


export interface IPropsChangeStatusTenantEntity extends IBaseProps, IChangeStatusCallback {
	callbackOptions: IChangeStatusTenantCallbackOptions;
	dialogConfirmationText: string;
	statusFlowChangeEvent?: IStatusFlowChangeEvent<TenantStatusEnum>;
}

export interface IPropsTenantEntity extends IBaseProps {
	tenant: Tenant;
}

export function adminTenantActions( storeId: string ) {
	return {
		...adapterActions<Tenant>( storeId ),

		changeStatus: createAction( `[${ storeId }] Change Status`, props<IPropsChangeStatusTenantEntity>() ),
		updateAdminState: createAction( `[${ storeId } ENTITY ACTION] State Update`, props<IPropsUpdateAdminState>() ),
		showAccountConfiguration: createAction( `[${ storeId }] Account config`, props<IPropsTenantEntity>() ),
		updateTenantContractLogs: createAction( `[${ storeId }] Update Tenant Contract Logs`, props<IPropsTenantEntity>() )
	};
}
